export default {
  mobileS: "320px",
  mobileM: "388px",
  mobileL: "450px",
  tablet: "768px",
  laptop: "991px",
  laptopL: "1440px",
};
